import React, { useMemo } from 'react'
import { STATUS_COLORS, hashColor } from './hexUtils'

export default function Legend({ clans = [], showClanPalette = true }) {
  const statusItems = useMemo(() => {
    return Object.entries(STATUS_COLORS).map(([status, c]) => ({
      key: status,
      label: status,
      fill: c.fill.replace(/22$/,''), // más sólido en swatch
      stroke: c.stroke,
    }))
  }, [])

  const clanItems = useMemo(() => {
    if (!showClanPalette) return []
    return (Array.isArray(clans) ? clans : []).slice(0, 12).map((c) => {
      const fill = hashColor(String(c.slug || c.name || c.id || 'clan'))
      return {
        key: c.slug || c.name || c.id,
        label: c.name || c.slug || `Clan ${c.id}`,
        fill,
        stroke: '#ffffff',
      }
    })
  }, [clans, showClanPalette])

  return (
    <div className="hexmap-legend" aria-label="Leyenda del mapa">
      {statusItems.map((it) => (
        <div className="hexmap-legend-item" key={`status-${it.key}`}>
          <span
            className="hexmap-legend-swatch"
            style={{
              background: it.fill,
              borderColor: it.stroke,
            }}
            aria-hidden="true"
          />
          <span>{it.label}</span>
        </div>
      ))}

      {clanItems.length > 0 && (
        <>
          {clanItems.map((it) => (
            <div className="hexmap-legend-item" key={`clan-${it.key}`}>
              <span
                className="hexmap-legend-swatch"
                style={{
                  background: it.fill,
                  borderColor: '#fff',
                }}
                aria-hidden="true"
              />
              <span>{it.label}</span>
            </div>
          ))}
        </>
      )}
    </div>
  )
}